import React, {Component} from 'react';
import {
    Button,
    Modal,
    Form,
    Message,
    List
} from 'semantic-ui-react';
import update from 'react-addons-update';

import IngredientData from "../../data/IngredientData";
import CustomDivider from "../extras/CustomDivider";
import ProductIngredientItem from "./ProductIngredientItem";
import {connect} from "react-redux";
import {addProductIngredient, listProductIngredients} from "../../actions/ProductIngredientActions";
import {openModalProductIngredients} from "../../actions/ModalProductIngredientsActions";
import Loading from "../extras/Loading";
import {showAlert} from "../../actions/AlertAction";
import RecipeIngredientData from "../../data/RecipeIngredientData";

class RecipeIngredientsDialog extends Component {

    constructor(props) {
        super(props);

        this.state = {
            ingredients: [],
            ingredient_error: false,
            quantity_error: false,
            loading: true,
            data:{
                ingredient:null,
                quantity:'',
                recipe: null
            },
            loading_add:false,
            id: null,
            options: [],
            height: 80
        };

        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentWillReceiveProps(nextProps){
        if(nextProps.modal.id && nextProps.modal.id !== this.state.id){
            this.setState({loading:true, height:80, id: nextProps.modal.id});
            this.initialFetch(nextProps.modal.id);
        }
    }

    componentWillMount(){
        IngredientData.list().then(ingredients => {
            let options = ingredients.map(ingredient => {
                return {key:ingredient.id, value:ingredient.id, text:`${ingredient.name} - ${ingredient.unit}`}
            });
            this.setState({options});
        });
    };

    async initialFetch(id) {
        let ingredients = await RecipeIngredientData.list(id);
        let height = ingredients.length > 0 ? 200:80;
        this.setState({loading: false, height});
        this.props.listProductIngredients(ingredients);
    }

    handleClose = () => {
        this.setState({
            id: null,
            ingredient_error: false,
            quantity_error: false,
            loading: false,
            loading_add: false,
            height: 80
        });
        this.props.openModalProductIngredients({
            is_open:false,
            loading:false,
            name:null,
            id:null
        });
        this.props.listProductIngredients([]);
    };

    handleOpen = () => {
        this.setState({open: true});
    };

    async handleSubmit() {
        if(this.state.data.ingredient === null){
            this.setState({ingredient_error:true});
        }else if(this.state.data.quantity < 0){
            this.setState({quantity_error:true});
        }else {
            let data = this.state.data;
            data.recipe = this.state.id;
            this.add(data);
        }
    };

    handleChange = (e, { name, value }) => {
        let ingredient = update(this.state, {
            data: {
                [name]: {$set: value}
            }
        });
        this.setState(ingredient);
        this.setState({ingredient_error:false, quantity_error:false});
    };

    async add(data) {
        this.setState({loading_add:true});
        RecipeIngredientData.add(data, (res) => {
            if (res.save) {
                this.props.addProductIngredient(res.data);
            } else {
                this.props.showAlert({
                    show:true,
                    type:'error',
                    message:'Este ingrediente ya está en la lista!'
                });
            }
            this.setState({loading_add:false});
        });
    };

    render() {
        let listItems = this.props.ingredients.map(function (ingredient) {
            return (
                <ProductIngredientItem {...ingredient} key={ingredient.id}/>
            )
        }, this);

        let data = (this.props.ingredients.length > 0 ? listItems :
            <Message icon='bell' header='No hay información registrada'/>
        );

        return (
            <div>
                <Modal open={this.props.modal.is_open} dimmer='inverted' onClose={this.handleClose} size='tiny'>
                    <Modal.Header>{`Ingredientes - ${this.props.modal.name}`}</Modal.Header>
                    <Modal.Content>
                        <Modal.Description>
                            <Message>
                                <Message.Header>Información</Message.Header>
                                La cantidad de ingredientes que se agregen a esta receta son para la elaboración de una porción.
                            </Message>
                            <Form onSubmit={this.handleSubmit}>
                                <Form.Group>
                                    <Form.Dropdown
                                        options={this.state.options}
                                        placeholder='Ingredientes'
                                        name='ingredient'
                                        onChange={this.handleChange}
                                        search
                                        selection
                                        width={8}
                                        error={this.state.ingredient_error}
                                    />
                                    <Form.Input
                                        placeholder='Cant.'
                                        type='number'
                                        name='quantity'
                                        min={0}
                                        width={4}
                                        step={'.01'}
                                        value={this.state.data.quantity}
                                        onChange={this.handleChange}
                                        error={this.state.quantity_error}
                                    />
                                    <Form.Button
                                        circular
                                        primary
                                        icon='add'
                                        width={2}
                                        disabled={this.state.loading_add}
                                        loading={this.state.loading_add}
                                    />
                                </Form.Group>
                            </Form>
                            <CustomDivider/>
                            <div className='modal-content-scroll' style={{height:this.state.height}}>
                                <List divided verticalAlign='middle'>
                                    {this.state.loading ? <Loading /> : data}
                                </List>
                            </div>
                        </Modal.Description>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button icon='x' labelPosition='left' onClick={this.handleClose} content="Cerrar"/>
                    </Modal.Actions>
                </Modal>
            </div>
        );
    }
}

function mapDispatchToProps(dispatch){
    return {
        listProductIngredients(product_ingredients) {
            dispatch(listProductIngredients(product_ingredients));
        },
        openModalProductIngredients(modal){
            dispatch(openModalProductIngredients(modal))
        },
        showAlert(alert) {
            dispatch(showAlert(alert));
        },
        addProductIngredient(ingredient){
            dispatch(addProductIngredient(ingredient))
        }
    }
}

function mapStateToProps(state){
    return{
        ingredients: state.get('product_ingredients'),
        modal: state.get('modal_product_ingredients')
    };
}


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(RecipeIngredientsDialog)



// WEBPACK FOOTER //
// ./src/components/inventories/RecipeIngredientsDialog.js